var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKaspiRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 27,
    rx: 2.5,
    fill: "#F14635",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0703 14.8169V17.9998H8.5V9.99976H11.248C12.139 9.99976 12.7269 10.2442 13.2296 10.658C13.7324 11.0718 13.9837 11.6487 13.9837 12.3888C13.9837 12.7972 13.8773 13.1499 13.6644 13.447C13.4515 13.7442 13.1411 13.9839 12.7332 14.1662C13.1948 14.3047 13.5266 14.5362 13.7288 14.8607C13.931 15.1852 14.032 15.5862 14.032 16.0638V16.649C14.032 16.8714 14.0616 17.1038 14.1206 17.3462C14.1796 17.5887 14.2807 17.7682 14.4238 17.8849V17.9998H12.8083C12.6652 17.8831 12.5731 17.6899 12.5319 17.4201C12.4908 17.1503 12.4702 16.8896 12.4702 16.638V16.0748C12.4702 15.6774 12.3637 15.3684 12.1508 15.1478C11.9379 14.9272 11.6365 14.8169 11.2465 14.8169H10.0703ZM10.0703 13.2H10.9434C11.3111 13.2 11.5847 13.1346 11.7641 13.0038C11.9435 12.873 12.0331 12.6793 12.0331 12.4227C12.0331 12.1711 11.9427 11.9711 11.7618 11.8227C11.581 11.6742 11.3156 11.6 10.9658 11.6H10.0703V13.2ZM17.1366 14.7998V16.3998H20.2772V17.9998H15.5663V9.99976H20.2772V11.5998H17.1366V13.1998H20.2772V14.7998H17.1366ZM21.8475 17.9998V9.99976H24.2029C25.1582 9.99976 26.0206 10.3481 26.6396 10.9697C27.2586 11.5913 27.5681 12.3888 27.5681 13.3623V14.6802C27.5681 15.6573 27.2586 16.4548 26.6396 17.0728C26.0206 17.6908 25.1582 17.9998 24.2029 17.9998H21.8475ZM23.4177 11.6V16.4H24.2029C24.6231 16.4 25.122 16.2292 25.3788 15.8876C25.6356 15.546 25.7732 14.9339 25.7732 14.4V13.6C25.7732 13.0693 25.6356 12.4501 25.3788 12.11C25.122 11.77 24.6231 11.6 24.2029 11.6H23.4177Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaspiRed);
export default __webpack_public_path__ + "static/media/kaspi-red.2aa693e0d32c78750b9cc3ef584589df.svg";
export { ForwardRef as ReactComponent };